export const name = 'LayoutAspect'

export const defaultModel = {
    layoutCounter: 0
}

export const functionLibrary = {
    getCompClientYForScroll: (compId, windowObject, wixAdsHeight) => {
        if (!compId) {
            return 0
        }
        const bodyTop = windowObject.document.body.getBoundingClientRect().top
        const compTop = windowObject.document.getElementById(compId).getBoundingClientRect().top
        return compTop - bodyTop - wixAdsHeight
    }
}
